import React from 'react'
import '../../../styles/containers/Prayer/components/faith-card.scss';
function FaithCard(props) {
    return (
        <div className={`faith-container d-flex flex-column justify-content-around ${props.faithSelected?'faith-selected-border':''}`}>
            <div className='d-flex justify-content-center'>{props.symbol.render()}</div>
            <div className='d-flex justify-content-center faith-name'>{props.name}</div>
        </div>
    )
}

export default FaithCard
